import { useState, useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { darken } from '@mui/material/styles';
import { Context } from '../../AuthContext';

const SelectPlanPage = () => {
  const { user } = useContext(Context);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isLegacy = searchParams.get('legacy') === 'true';
  const [selectingFree, setSelectingFree] = useState(false);

  const handleSelectFree = async () => {
    if (selectingFree) return;
    if (isLegacy) {
      navigate('/subscription-expired');
      return;
    }
    setSelectingFree(true);
    try {
      const token = await user.getIdToken();
      const response = await fetch(process.env.REACT_APP_FLASK_WEBSERVER + 'select_free_plan', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log('response: ', response);
      if (!response.ok) {
        throw new Error(`select_free_plan failed: ${response.status}`);
      }
      navigate('/tryrnai');
    } catch (error) {
      console.error('Failed to select free plan:', error);
      setSelectingFree(false);
    }
  };

  useEffect(() => {
    const scriptSrc = 'https://js.stripe.com/v3/pricing-table.js';
    if (document.querySelector(`script[src="${scriptSrc}"]`)) return;
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <h2 style={{ marginBottom: '8px' }}>Select Plan</h2>
      <p style={{ color: '#596274', fontSize: '16px', margin: '12px 0 0 0' }}>
        Select the account plan that fits how youʼd like to use TSP.
      </p>
      <p style={{ color: '#596274', fontSize: '16px', marginTop: 0, marginBottom: '24px' }}>
        Youʼll be able to change between plans at any time in your account settings.
      </p>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '60px',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            width: '420px',
            textAlign: 'left',
            padding: '80px 80px 0 80px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <div>
              <p style={{ fontSize: '20px', fontWeight: '600' }}>TSP Explorer (Free)</p>

              <p
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  color: 'rgba(26, 26, 26, 0.5)',
                  lineHeight: 1.2,
                }}
              >
                Designed for light, individual use, Explorer provides access to the core
                functionality of The Simple Platform within defined limits. It is ideal for
                exploring early ideas or managing focused research activity. As collaboration and
                Discovery needs grow, many researchers transition to Full Access to support expanded
                scale and advanced capabilities. Upgrade at any time as your work evolves.
              </p>
            </div>
            <img src="/subscriptionIcons/Explorer.svg" width={100} />
          </div>
          <p
            style={{
              fontSize: '36px',
              fontWeight: '600',
              marginTop: 24,
              marginBottom: 24,
            }}
          >
            Free
          </p>
          <Button
            variant="contained"
            onClick={handleSelectFree}
            disabled={selectingFree}
            sx={{
              width: '100%',
              height: '45px',
              textTransform: 'none',
              fontSize: '16px',
              backgroundColor: 'rgb(53, 106, 195)',
              borderColor: 'rgb(53, 106, 195)',
              '&:hover': {
                backgroundColor: darken('rgb(53, 106, 195)', 0.04),
                borderColor: darken('rgb(53, 106, 195)', 0.05),
                boxShadow: 'none',
              },
            }}
          >
            {selectingFree ? 'Selecting…' : 'Select Explorer'}
          </Button>
          <p style={{ fontSize: '14px', marginBottom: '4px', marginTop: '8px' }}>This includes:</p>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
            }}
          >
            <CheckCircleIcon sx={{ color: 'gray', fontSize: 15 }} />
            <p style={{ fontSize: '14px', margin: '3px' }}>No payment required</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <CheckCircleIcon sx={{ color: 'gray', fontSize: 15 }} />
            <p style={{ fontSize: '14px', margin: '3px' }}>Core platform access</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <CheckCircleIcon sx={{ color: 'gray', fontSize: 15 }} />
            <p style={{ fontSize: '14px', margin: '3px' }}>Limited collaboration</p>
          </div>
        </div>

        <div style={{ width: '580px' }}>
          <stripe-pricing-table
            pricing-table-id={process.env.REACT_APP_STRIPE_PRICING_TABLE_ID}
            publishable-key={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}
            customer-email={user?.email || undefined}
          ></stripe-pricing-table>
        </div>
      </div>
    </div>
  );
};

export default SelectPlanPage;
